// src/components/ProductGridWithBanner.jsx
import aurusSmartHouseImg from '../../assets/img/Aurus/bp-house/story.jpg';

const UmniyDom = () => {
  return (
    <section className="bp-house">
      
      {/* Блок "Умный дом" */}
        <div className="wrapper category-block">
          <div className="third-story-block">
            <img src={aurusSmartHouseImg} className="third-story-block__image" alt="Умный дом" />
            <div className="third-story-block__info">
              <div className="third-story-block__title">Умный дом</div>
              <div className="third-story-block__description">
                Все устройства AURUS подключаются к системе «Умный дом». Интеллектуальная система в несколько кликов позволит
                создать и контролировать микроклимат в помещении. Главная ее функция — удаленное управление техникой через
                мобильное приложение HOMMYN.
              </div>
              <div className="third-story-block__apps">
                <a
                  href="https://apps.apple.com/ru/app/hommyn/id1510775801"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="third-story-block__apps-item ios"
                >
                  iOS
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.hommyn.app"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="third-story-block__apps-item android"
                >
                  Android
                </a>
              </div>
            </div>
          </div>
        </div>

    </section>
    
  );
};

export default UmniyDom;
